import {
  PortvilleRoommate,
  PortvilleRoommateAttachment
} from '../types/portvilleRoom';

export const MAX_PORTVILLE_ROOMMATES = 3;

export const ROOMMATE_SLOT_FIELDS = [
  {
    name: 'roommateInfo',
    contact: 'roommateContact',
    attachment: 'roommateAttachment'
  },
  {
    name: 'roommate2Info',
    contact: 'roommate2Contact',
    attachment: 'roommate2Attachment'
  },
  {
    name: 'roommate3Info',
    contact: 'roommate3Contact',
    attachment: 'roommate3Attachment'
  }
] as const;

const toOptionalDate = (value: any): Date | undefined => {
  if (!value) return undefined;
  if (value instanceof Date) return value;
  if (typeof value.toDate === 'function') return value.toDate();
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? undefined : date;
};

const normalizeAttachment = (value: any): PortvilleRoommateAttachment | undefined => {
  if (!value || typeof value !== 'object') return undefined;
  if (
    typeof value.id !== 'string' ||
    typeof value.name !== 'string' ||
    typeof value.storagePath !== 'string' ||
    typeof value.size !== 'number' ||
    typeof value.contentType !== 'string'
  ) {
    return undefined;
  }

  return {
    id: value.id,
    name: value.name,
    storagePath: value.storagePath,
    size: value.size,
    contentType: value.contentType,
    uploadedAt: toOptionalDate(value.uploadedAt)
  };
};

export const normalizePortvilleRoommates = (data: any): PortvilleRoommate[] => {
  const slots = ROOMMATE_SLOT_FIELDS.map((fields) => ({
    name: typeof data?.[fields.name] === 'string' ? data[fields.name] : '',
    contact: typeof data?.[fields.contact] === 'string' ? data[fields.contact] : '',
    attachment: normalizeAttachment(data?.[fields.attachment])
  }));

  const explicitCount =
    Number.isInteger(data?.roommateCount) &&
    data.roommateCount >= 0 &&
    data.roommateCount <= MAX_PORTVILLE_ROOMMATES
      ? data.roommateCount
      : undefined;

  const inferredCount = slots.reduce(
    (highest, slot, index) =>
      slot.name.trim() || slot.contact.trim() || slot.attachment ? index + 1 : highest,
    0
  );
  const count = explicitCount ?? inferredCount;

  return slots.slice(0, count);
};

